// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"705":"95a8f235","787":"2dcd4a17","879":"595f1945"}[chunkId] + ".chunk.js";
};